import React, { useEffect, useState } from "react";
import { pillarApi, pillarErr, pillarDate } from "@/lib/pillarApi";
import { inputCls, labelCls, Pill, ErrorLine } from "./ui";

export default function VocationTrackPanel({ residentId, onChanged }) {
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  const url = `/residents/${residentId}/vocation-track`;
  useEffect(() => { pillarApi.get(url).then(setD).catch((e) => setError(pillarErr(e))); }, [residentId]); // eslint-disable-line react-hooks/exhaustive-deps
  const run = async (p) => { setError(null); try { setD(await p); onChanged?.(); } catch (e) { setError(pillarErr(e)); } };
  const pick = (id) => {
    if (d.selected && !window.confirm("Switch this resident's vocation track? Phase progress on the current track starts over.")) return;
    run(pillarApi.post(url, { track_id: id }));
  };
  if (!d) return <ErrorLine testId="vt-staff-error">{error}</ErrorLine>;
  return (
    <div data-testid="vt-staff" className="p-3 border border-white/10 rounded-sm space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <span className={labelCls + " !mb-0"}>Vocation Track</span>
        <Pill tone={d.selected ? "green" : "dim"} data-testid="vt-staff-status">{d.selected ? `${d.completed}/4 phases` : "not picked"}</Pill>
        {d.selected?.selected_at && <span className="text-[11px] text-nex-muted">picked {pillarDate(d.selected.selected_at)}</span>}
      </div>
      <select data-testid="vt-staff-select" className={inputCls} value={d.selected?.id || ""} onChange={(e) => e.target.value && pick(e.target.value)}>
        <option value="">Choose one of the 25 tracks…</option>
        {d.catalog.map((c) => <optgroup key={c.category} label={c.category}>{c.tracks.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}</optgroup>)}
      </select>
      {d.selected && (
        <ul className="space-y-1.5">
          {d.phases.map((p) => (
            <li key={p.phase} className="flex items-start gap-2 text-sm">
              <input type="checkbox" data-testid={`vt-staff-phase-${p.phase}`} checked={p.done} className="mt-1 accent-[#d4a017]"
                onChange={(e) => run(pillarApi.patch(`${url}/phases/${p.phase}`, { done: e.target.checked }))} />
              <span className={p.done ? "text-nex-muted line-through" : "text-nex-silver"}>Phase {p.phase} · {p.title} <span className="text-[11px] text-nex-muted no-underline">· {p.detail}{p.done ? ` · done ${pillarDate(p.done_at)} by ${p.done_by?.name || "—"}` : ""}</span></span>
            </li>
          ))}
        </ul>
      )}
      <ErrorLine testId="vt-staff-error">{error}</ErrorLine>
    </div>
  );
}
